export default __webpack_public_path__ + "static/media/goodday-raffle-banner.52314c8b.png";